var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2967 58.1356L34.6603 46.4992L46.2967 34.8628V10.8672L13.0639 44.1C12.4277 44.7363 12.0703 45.5993 12.0703 46.4992C12.0703 47.399 12.4277 48.262 13.0639 48.8984L46.2967 82.1312C46.2967 82.1312 51.387 78.7377 51.387 70.2538C51.1236 65.7517 49.3273 61.4753 46.2967 58.1356Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4807 44.2374L36.703 44.4597L46.2999 34.8628V10.8672L28.3125 28.8529C29.665 34.5989 32.4786 39.8982 36.4807 44.2374Z",
    fill: "#1D78F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9295 41.8925L39.0992 42.0621L46.2969 34.8645V10.8672L31.25 25.9107C32.1935 31.8738 34.8633 37.4299 38.9295 41.8925Z",
    fill: "#126AE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2992 34.8628V10.8672L34.4219 22.7445C34.6819 29.0483 37.1928 35.0502 41.4991 39.6612L46.2992 34.8628Z",
    fill: "#0B60DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8125 22.7445C37.8125 30.7973 43.5934 36.9481 43.8954 37.262L46.2963 34.8628V10.8672L38.1146 19.049C37.9116 20.2703 37.8106 21.5064 37.8125 22.7445Z",
    fill: "#0154CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3012 34.8628L57.9359 46.4992L46.3012 58.1356V82.1312L79.5323 48.8984C80.1685 48.262 80.5259 47.399 80.5259 46.4992C80.5259 45.5993 80.1685 44.7363 79.5323 44.1L46.3012 10.8672C46.3012 10.8672 41.2109 14.2607 41.2109 22.7445C41.4742 27.2467 43.2706 31.5231 46.3012 34.8628Z",
    fill: "#2482FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1143 48.7613L55.8921 48.5391L46.2969 58.136V82.1316L64.2826 64.1459C62.9301 58.3999 60.1165 53.1006 56.1143 48.7613Z",
    fill: "#1D78F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6547 51.1072L53.485 50.9375L46.2891 58.1352V82.1325L61.3326 67.089C60.389 61.1262 57.7198 55.5703 53.6547 51.1072Z",
    fill: "#126AE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2969 58.1344V82.13L58.1742 70.2527C57.9139 63.9486 55.4023 57.9467 51.0953 53.3359L46.2969 58.1344Z",
    fill: "#0B60DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7807 70.2519C54.7807 62.199 48.9998 56.0483 48.6961 55.7344L46.2969 58.1336V82.1292L54.4787 73.9474C54.6808 72.726 54.7818 71.4899 54.7807 70.2519Z",
    fill: "#0154CE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2995 58.1364L34.6631 46.5H15.7578V51.5903L46.2995 82.132C46.2995 82.132 51.3898 78.7385 51.3898 70.2547C51.1265 65.7525 49.3302 61.4761 46.2995 58.1364Z",
    fill: "#2684FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.ec628eb839395f4270e5cd538f28e573.svg";
export { ForwardRef as ReactComponent };